const REPORT_VERSION_NEW = 'NEW';
const REPORT_VERSION_LEGACY = 'LEGACY';

export const reportVersions = { REPORT_VERSION_NEW, REPORT_VERSION_LEGACY };
